<template>

  <p v-if="error" class="error">{{ error }}</p>
  <div class="cell small-12">
    <h1>Non-Standard Requirements</h1>
    <p>Are you aware of any requirements that your company may have that would not normally be considered part of standard payroll operations?</p>

    <div class="cell small-6">
      <form class="fieldset" @submit.prevent>
            <label class="radio-label custom-check"><input type="radio" value=true v-model="formData.hasNonStandardRequirements">Yes<span class="radiomark"></span></label>
            <label class="radio-label custom-check"><input type="radio" value=false v-model="formData.hasNonStandardRequirements">No<span class="radiomark"></span></label>
      </form>
    </div>

  </div>


</template>


<script setup>

import { ref, watch } from 'vue'

const error = ref(null)


const props = defineProps({
  formData: Object
})


const validateStep = () => {
  if (props.formData.hasNonStandardRequirements === undefined || props.formData.hasNonStandardRequirements === null || props.formData.hasNonStandardRequirements === '') {
    error.value = 'Please select an option.';
    return false;
  }
  error.value = null;
  return true;
}


const executeStep = async () => {
  return true;
}





defineExpose({ validateStep, executeStep });

</script>